import { MantineTheme, Text } from "@mantine/core";
import { createStyles } from "@mantine/emotion";
import { FC } from "react";

const useStyles = createStyles((_theme: MantineTheme) => ({
  errorText: {
    color: "red",
    fontSize: "0.813rem",
    fontWeight: 400,
    lineHeight: "1.044rem",
    marginLeft: "0px",
    marginBottom: "10px",
  },
}));

type Props = {
  errorText: string;
  style?: any;
};

const ErrorMessage: FC<Props> = ({ style, errorText }) => {
  const { classes } = useStyles();
  return (
    <Text className={classes.errorText} style={style}>
      {errorText}
    </Text>
  );
};

export default ErrorMessage;
